import indexOf from "lodash/indexOf";

import store from "../../store";
import { REQUIRED } from "../../constants/validations";
import { MORTGAGE_BROKER } from "../../constants/contact_id_status";
import {
  FIX_FLIP,
  RESIDENTIAL,
  COMMERCIAL,
  TDS,
} from "../../constants/typeOfHomeOptions";

const validations = (values) => {
  let errors = {};

  const { id_status } = store.getState().form.contacts;
  const { type_of_loan } = store.getState().form.accounts;

  if (!values.loan_amount) {
    errors.purchase_price = REQUIRED;
  }

  if (!values.lien_position) {
    errors.lien_position = REQUIRED;
  }

  if (!values.loan_terms) {
    errors.loan_terms = REQUIRED;
  }

  if (id_status === MORTGAGE_BROKER.value) {
    if (!values.broker_points) {
      errors.broker_points = REQUIRED;
    }

    if (!values.broker_processing_fee_5) {
      errors.broker_processing_fee_5 = REQUIRED;
    }
  }

  if (type_of_loan === FIX_FLIP.value) {
    if (!values.arv_market_value) {
      errors.arv_market_value = REQUIRED;
    }

    if (!values.rehab_amount) {
      errors.rehab_amount = REQUIRED;
    }

    if (!values.sq_ft_addition) {
      errors.sq_ft_addition = REQUIRED;
    }
  }

  if (
    indexOf([RESIDENTIAL.value, COMMERCIAL.value, TDS.value], type_of_loan) !==
    -1
  ) {
    if (!values.property_income) {
      errors.property_income = REQUIRED;
    }
  }

  return errors;
};

export default validations;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/validations4.js